import { gaPageView } from './googleAnalytics'
import { facebookPixelPageView } from './facebook'

export const initPageView = () => {
  gaPageView()
  facebookPixelPageView()
}
